function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Controller as e } from "@hotwired/stimulus";
import t from "cable_ready";
import { createConsumer as r } from "@rails/actioncable";
var l = {
  reflexAttribute: "data-reflex",
  reflexPermanentAttribute: "data-reflex-permanent",
  reflexRootAttribute: "data-reflex-root",
  reflexSuppressLoggingAttribute: "data-reflex-suppress-logging",
  reflexDatasetAttribute: "data-reflex-dataset",
  reflexDatasetAllAttribute: "data-reflex-dataset-all",
  reflexSerializeFormAttribute: "data-reflex-serialize-form",
  reflexFormSelectorAttribute: "data-reflex-form-selector",
  reflexIncludeInnerHtmlAttribute: "data-reflex-include-inner-html",
  reflexIncludeTextContentAttribute: "data-reflex-include-text-content"
};
var n = {};
var o = {
  set: function set(e) {
    var _this = this;
    n = _objectSpread(_objectSpread({}, l), e.schema);
    var _loop = function _loop(_e) {
      Object.defineProperty(_this, _e.slice(0, -9), {
        get: function get() {
          return n[_e];
        }
      });
    };
    for (var _e in n) {
      _loop(_e);
    }
  }
};
var a = !1;
var s = {
  get enabled() {
    return a;
  },
  get disabled() {
    return !a;
  },
  get value() {
    return a;
  },
  set: function set(e) {
    a = !!e;
  },
  set debug(e) {
    a = !!e;
  }
};
var i = {};
var d = function d(e, t, r, l, n, o) {
    var a = i[e];
    s.disabled || a.promise.data.suppressLogging || (a.timestamp = new Date(), console.log("\u2191 stimulus \u2191 ".concat(t), {
      reflexId: e,
      args: r,
      controller: l,
      element: n,
      controllerElement: o
    }));
  },
  c = function c(e, t) {
    var _ref = e || {},
      r = _ref.detail,
      _ref2 = r || {},
      l = _ref2.selector,
      n = _ref2.payload,
      _ref3 = r.stimulusReflex || {},
      o = _ref3.reflexId,
      a = _ref3.target,
      d = _ref3.morph,
      c = i[o];
    if (s.disabled || c.promise.data.suppressLogging) return;
    var u = c.totalOperations > 1 ? " ".concat(c.completedOperations, "/").concat(c.totalOperations) : "",
      f = c.timestamp ? "in ".concat(new Date() - c.timestamp, "ms") : "CLONED",
      m = e.type.split(":")[1].split("-").slice(1).join("_");
    console.log("\u2193 reflex \u2193 ".concat(a, " \u2192 ").concat(l || "∞").concat(u, " ").concat(f), {
      reflexId: o,
      morph: d,
      operation: m,
      halted: t,
      payload: n
    });
  },
  u = function u(e) {
    var _ref4 = e || {},
      t = _ref4.detail,
      _ref5 = t.stimulusReflex || {},
      r = _ref5.reflexId,
      l = _ref5.target,
      n = _ref5.payload,
      o = i[r];
    if (s.disabled || o.promise.data.suppressLogging) return;
    var a = o.timestamp ? "in ".concat(new Date() - o.timestamp, "ms") : "CLONED";
    console.log("\u2193 reflex \u2193 ".concat(l, " ").concat(a, " %cERROR: ").concat(e.detail.body), "color: #f00;", {
      reflexId: r,
      payload: n
    });
  };
var f = !0;
var m = {
  get enabled() {
    return f;
  },
  get disabled() {
    return !f;
  },
  get value() {
    return f;
  },
  set: function set(e) {
    f = !!e;
  },
  set deprecate(e) {
    f = !!e;
  }
};
var p = function p() {
    var e = window.crypto || window.msCrypto;
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (t) {
      return (t ^ e.getRandomValues(new Uint8Array(1))[0] & 15 >> t / 4).toString(16);
    });
  },
  x = function x(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
    return "string" != typeof e ? "" : (e = e.replace(/[\s_](.)/g, function (e) {
      return e.toUpperCase();
    }).replace(/[\s_]/g, "").replace(/^(.)/, function (e) {
      return e.toLowerCase();
    }), t && (e = e.substr(0, 1).toUpperCase() + e.substr(1)), e);
  },
  h = function h(e, t) {
    document.dispatchEvent(new CustomEvent(e, {
      bubbles: !0,
      cancelable: !1,
      detail: t
    })), window.jQuery && window.jQuery(document).trigger(e, t);
  },
  g = function g(e) {
    if ("" !== e.id) return "//*[@id='" + e.id + "']";
    if (e === document.body) return "/html/body";
    var t = 0;
    var r = e !== null && e !== void 0 && e.parentNode ? e.parentNode.childNodes : [];
    for (var l = 0; l < r.length; l++) {
      var _n = r[l];
      if (_n === e) {
        return "".concat(g(e.parentNode), "/").concat(e.tagName.toLowerCase(), "[").concat(t + 1, "]");
      }
      1 === _n.nodeType && _n.tagName === e.tagName && t++;
    }
  },
  b = function b(e) {
    return document.evaluate(e, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
  },
  y = function y(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
    var r = document.evaluate(e, document, null, XPathResult.ORDERED_NODE_SNAPSHOT_TYPE, null),
      l = [];
    for (var _e2 = 0; _e2 < r.snapshotLength; _e2++) {
      l.push(r.snapshotItem(_e2));
    }
    return t ? l.reverse() : l;
  },
  v = function v() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var t = e.filter(function (e) {
      return e && String(e).length;
    }).map(function (e) {
      return e.trim();
    }).join(" ").trim();
    return t.length ? t : null;
  },
  E = function E(e) {
    return e && e.length ? e.split(" ").filter(function (e) {
      return e.trim().length;
    }) : [];
  },
  w = function w(e) {
    var t = Array.from(e.attributes).reduce(function (e, t) {
      return e[t.name] = t.value, e;
    }, {});
    if (t.checked = !!e.checked, t.selected = !!e.selected, t.tag_name = e.tagName, e.tagName.match(/select/i) || function (e) {
      return !!["checkbox", "radio"].includes(e.type) && document.querySelectorAll("input[type=\"".concat(e.type, "\"][name=\"").concat(e.name, "\"]")).length > 1;
    }(e)) {
      var _r = function (e) {
        return Array.from(e.querySelectorAll("option:checked")).concat(Array.from(document.querySelectorAll("input[type=\"".concat(e.type, "\"][name=\"").concat(e.name, "\"]"))).filter(function (e) {
          return e.checked;
        })).map(function (e) {
          return e.value;
        });
      }(e);
      t.values = _r, t.value = _r.join(",");
    } else t.value = e.value;
    return t;
  },
  C = function C(e, t) {
    if (!t || 0 === t.length) return [];
    var r = [e];
    var l = g(e);
    return t.forEach(function (e) {
      try {
        switch (e) {
          case "combined":
            m.enabled && console.warn("In the next version of StimulusReflex, the 'combined' option to data-reflex-dataset will become 'ancestors'."), r = [].concat(_toConsumableArray(r), _toConsumableArray(y("".concat(l, "/ancestor::*"), !0)));
            break;
          case "ancestors":
            r = [].concat(_toConsumableArray(r), _toConsumableArray(y("".concat(l, "/ancestor::*"), !0)));
            break;
          case "parent":
            r = [].concat(_toConsumableArray(r), _toConsumableArray(y("".concat(l, "/parent::*"))));
            break;
          case "siblings":
            r = [].concat(_toConsumableArray(r), _toConsumableArray(y("".concat(l, "/preceding-sibling::*|").concat(l, "/following-sibling::*"))));
            break;
          case "children":
            r = [].concat(_toConsumableArray(r), _toConsumableArray(y("".concat(l, "/child::*"))));
            break;
          case "descendants":
            r = [].concat(_toConsumableArray(r), _toConsumableArray(y("".concat(l, "/descendant::*"))));
            break;
          default:
            r = [].concat(_toConsumableArray(r), _toConsumableArray(document.querySelectorAll(e)));
        }
      } catch (e) {
        s.enabled && console.error(e);
      }
    }), r;
  },
  I = function I(e) {
    var t = {};
    return e && e.attributes && Array.from(e.attributes).forEach(function (e) {
      e.name.startsWith("data-") && (t[e.name] = e.value);
    }), t;
  };
var R = !1;
var S = {
  get disabled() {
    return !R;
  },
  set: function set(e) {
    R = e;
  }
};
var A = function A(e, t, r, l, n) {
  if (!r || !r.reflexData[l]) return;
  var o = r.reflexController[l],
    a = r.reflexData[l].target,
    s = a.split("#")[1],
    d = o[["before", "after", "finalize"].includes(e) ? "".concat(e).concat(x(s)) : "".concat(x(s, !1)).concat(x(e))],
    c = o[["before", "after", "finalize"].includes(e) ? "".concat(e, "Reflex") : "reflex".concat(x(e))];
  "function" == typeof d && d.call(o, t, a, r.reflexError[l], l, n), "function" == typeof c && c.call(o, t, a, r.reflexError[l], l, n), i[l] && e === i[l].finalStage && (Reflect.deleteProperty(r.reflexController, l), Reflect.deleteProperty(r.reflexData, l), Reflect.deleteProperty(r.reflexError, l));
};
document.addEventListener("stimulus-reflex:before", function (e) {
  return A("before", e.detail.element, e.detail.controller.element, e.detail.reflexId, e.detail.payload);
}, !0), document.addEventListener("stimulus-reflex:success", function (e) {
  A("success", e.detail.element, e.detail.controller.element, e.detail.reflexId, e.detail.payload), $("after", e.detail.element, e.detail.controller.element, e.detail.reflexId, e.detail.payload);
}, !0), document.addEventListener("stimulus-reflex:nothing", function (e) {
  $("success", e.detail.element, e.detail.controller.element, e.detail.reflexId, e.detail.payload);
}, !0), document.addEventListener("stimulus-reflex:error", function (e) {
  A("error", e.detail.element, e.detail.controller.element, e.detail.reflexId, e.detail.payload), $("after", e.detail.element, e.detail.controller.element, e.detail.reflexId, e.detail.payload);
}, !0), document.addEventListener("stimulus-reflex:halted", function (e) {
  return A("halted", e.detail.element, e.detail.controller.element, e.detail.reflexId, e.detail.payload);
}, !0), document.addEventListener("stimulus-reflex:after", function (e) {
  return A("after", e.detail.element, e.detail.controller.element, e.detail.reflexId, e.detail.payload);
}, !0), document.addEventListener("stimulus-reflex:finalize", function (e) {
  return A("finalize", e.detail.element, e.detail.controller.element, e.detail.reflexId, e.detail.payload);
}, !0);
var $ = function $(e, t, r, l, n) {
    if (!r) return void (s.enabled && !i[l].warned && (console.warn("StimulusReflex was not able execute callbacks or emit events for \"".concat(e, "\" or later life-cycle stages for this Reflex. The StimulusReflex Controller Element is no longer present in the DOM. Could you move the StimulusReflex Controller to an element higher in your DOM?")), i[l].warned = !0));
    if (!r.reflexController || r.reflexController && !r.reflexController[l]) return void (s.enabled && !i[l].warned && (console.warn("StimulusReflex detected that the StimulusReflex Controller responsible for this Reflex has been replaced with a new instance. Callbacks and events for \"".concat(e, "\" or later life-cycle stages cannot be executed.")), i[l].warned = !0));
    var _ref6 = r.reflexData[l] || {},
      o = _ref6.target,
      a = r.reflexController[l] || {},
      d = "stimulus-reflex:".concat(e),
      c = "".concat(d, ":").concat(o.split("#")[1]),
      u = {
        reflex: o,
        controller: a,
        reflexId: l,
        element: t,
        payload: n
      },
      f = {
        bubbles: !0,
        cancelable: !1,
        detail: u
      };
    r.dispatchEvent(new CustomEvent(d, f)), r.dispatchEvent(new CustomEvent(c, f)), window.jQuery && (window.jQuery(r).trigger(d, u), window.jQuery(r).trigger(c, u));
  },
  L = function L(e, t) {
    return E(t.getAttribute(o.controller)).reduce(function (r, l) {
      var n = e.getControllerForElementAndIdentifier(t, l);
      return n && n.StimulusReflex && r.push(n), r;
    }, []);
  },
  O = function O(e) {
    if (!e.cableReady) return;
    if (e.version.replace(".pre", "-pre") !== t.version) return void (s.enabled && console.error("Reflex failed due to cable_ready gem/NPM package version mismatch. Package versions must match exactly.\nNote that if you are using pre-release builds, gems use the \"x.y.z.preN\" version format, while NPM packages use \"x.y.z-preN\".\n\ncable_ready gem: ".concat(e.version, "\ncable_ready NPM: ").concat(t.version)));
    var r,
      l = [];
    for (var _t = e.operations.length - 1; _t >= 0; _t--) {
      e.operations[_t].stimulusReflex && (l.push(e.operations[_t]), e.operations.splice(_t, 1));
    }
    if (!l.some(function (e) {
      return e.stimulusReflex.url !== location.href;
    })) if (l.length && (r = l[0].stimulusReflex, r.payload = l[0].payload), r) {
      var _r2 = r,
        _n2 = _r2.reflexId,
        _o = _r2.payload;
      if (!i[_n2] && S.disabled) {
        var _e3 = b(r.xpathController),
          _t2 = b(r.xpathElement);
        _e3.reflexController = _e3.reflexController || {}, _e3.reflexData = _e3.reflexData || {}, _e3.reflexError = _e3.reflexError || {}, _e3.reflexController[_n2] = i.app.getControllerForElementAndIdentifier(_e3, r.reflexController), _e3.reflexData[_n2] = r, $("before", _t2, _e3, _n2, _o), _(r);
      }
      i[_n2] && (i[_n2].totalOperations = l.length, i[_n2].pendingOperations = l.length, i[_n2].completedOperations = 0, i[_n2].piggybackOperations = e.operations, t.perform(l));
    } else e.operations.length && i[e.operations[0].reflexId] && t.perform(e.operations);
  },
  _ = function _(e) {
    var t = e.reflexId;
    i[t] = {
      finalStage: "finalize"
    };
    var r = new Promise(function (r, l) {
      i[t].promise = {
        resolve: r,
        reject: l,
        data: e
      };
    });
    return r.reflexId = t, s.enabled && r["catch"](function () {}), r;
  },
  D = function (e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;
    var r;
    return function () {
      for (var _len = arguments.length, l = new Array(_len), _key = 0; _key < _len; _key++) {
        l[_key] = arguments[_key];
      }
      clearTimeout(r), r = setTimeout(function () {
        r = null, e.apply(void 0, l);
      }, t);
    };
  }(function () {
    document.querySelectorAll("[".concat(o.reflex, "]")).forEach(function (e) {
      var t = E(e.getAttribute(o.controller)),
        r = E(e.getAttribute(o.reflex)),
        l = E(e.getAttribute(o.action));
      r.forEach(function (r) {
        var n = function (e, t) {
          return t.find(function (t) {
            if (t.identifier) return function (e) {
              var t = e.match(/(?:.*->)?(.*?)(?:Reflex)?#/);
              return t ? t[1] : "";
            }(e).replace(/([a-z0–9])([A-Z])/g, "$1-$2").replace(/(::)/g, "--").toLowerCase() === t.identifier;
          }) || t[0];
        }(r, function (e, t) {
          var r = [];
          for (; t;) {
            r = r.concat(L(e, t)), t = t.parentElement;
          }
          return r;
        }(i.app, e));
        var o;
        n ? (o = "".concat(r.split("->")[0], "->").concat(n.identifier, "#__perform"), l.includes(o) || l.push(o)) : (o = "".concat(r.split("->")[0], "->stimulus-reflex#__perform"), t.includes("stimulus-reflex") || t.push("stimulus-reflex"), l.includes(o) || l.push(o));
      });
      var n = v(t),
        a = v(l);
      n && e.getAttribute(o.controller) != n && e.setAttribute(o.controller, n), a && e.getAttribute(o.action) != a && e.setAttribute(o.action, a);
    }), h("stimulus-reflex:ready");
  }, 20);
var T = /*#__PURE__*/function () {
  function T(e, t, r, l, n, o, a, s, i) {
    _classCallCheck(this, T);
    this.options = e, this.reflexElement = t, this.controllerElement = r, this.reflexController = l, this.permanentAttributeName = n, this.target = o, this.args = a, this.url = s, this.tabId = i;
  }
  _createClass(T, [{
    key: "attrs",
    get: function get() {
      return this._attrs = this._attrs || this.options.attrs || w(this.reflexElement), this._attrs;
    }
  }, {
    key: "reflexId",
    get: function get() {
      return this._reflexId = this._reflexId || this.options.reflexId || p(), this._reflexId;
    }
  }, {
    key: "selectors",
    get: function get() {
      return this._selectors = this._selectors || this.options.selectors || function (e) {
        var t = [];
        for (; 0 === t.length && e;) {
          var _r3 = e.getAttribute(o.reflexRoot);
          if (_r3) {
            0 === _r3.length && e.id && (_r3 = "#".concat(e.id));
            var _l = _r3.split(",").filter(function (e) {
              return e.trim().length;
            });
            s.enabled && 0 === _l.length && console.error("No value found for ".concat(o.reflexRoot, ". Add an #id to the element or provide a value for ").concat(o.reflexRoot, "."), e), t = t.concat(_l.filter(function (e) {
              return document.querySelector(e);
            }));
          }
          e = e.parentElement ? e.parentElement.closest("[".concat(o.reflexRoot, "]")) : null;
        }
        return t;
      }(this.reflexElement), "string" == typeof this._selectors ? [this._selectors] : this._selectors;
    }
  }, {
    key: "resolveLate",
    get: function get() {
      return this.options.resolveLate || !1;
    }
  }, {
    key: "dataset",
    get: function get() {
      return this._dataset = this._dataset || function (e) {
        var t = e.attributes[o.reflexDataset],
          r = e.attributes[o.reflexDatasetAll],
          l = t && t.value.split(" ") || [],
          n = r && r.value.split(" ") || [],
          a = C(e, l),
          s = C(e, n),
          i = a.reduce(function (e, t) {
            return _objectSpread(_objectSpread({}, I(t)), e);
          }, {}),
          d = {
            dataset: _objectSpread(_objectSpread({}, I(e)), i),
            datasetAll: {}
          };
        return s.forEach(function (e) {
          var t = I(e);
          Object.keys(t).forEach(function (e) {
            var r = t[e];
            d.datasetAll[e] && Array.isArray(d.datasetAll[e]) ? d.datasetAll[e].push(r) : d.datasetAll[e] = [r];
          });
        }), d;
      }(this.reflexElement), this._dataset;
    }
  }, {
    key: "innerHTML",
    get: function get() {
      return this.includeInnerHtml ? this.reflexElement.innerHTML : "";
    }
  }, {
    key: "textContent",
    get: function get() {
      return this.includeTextContent ? this.reflexElement.textContent : "";
    }
  }, {
    key: "xpathController",
    get: function get() {
      return g(this.controllerElement);
    }
  }, {
    key: "xpathElement",
    get: function get() {
      return g(this.reflexElement);
    }
  }, {
    key: "formSelector",
    get: function get() {
      var e = this.reflexElement.attributes[o.reflexFormSelector] ? this.reflexElement.attributes[o.reflexFormSelector].value : void 0;
      return this.options.formSelector || e;
    }
  }, {
    key: "includeInnerHtml",
    get: function get() {
      var e = this.reflexElement.attributes[o.reflexIncludeInnerHtml] || !1;
      return !(!this.options.includeInnerHTML && !e) && "false" !== e.value;
    }
  }, {
    key: "includeTextContent",
    get: function get() {
      var e = this.reflexElement.attributes[o.reflexIncludeTextContent] || !1;
      return !(!this.options.includeTextContent && !e) && "false" !== e.value;
    }
  }, {
    key: "suppressLogging",
    get: function get() {
      return this.options.suppressLogging || this.reflexElement.attributes[o.reflexSuppressLogging] || !1;
    }
  }, {
    key: "valueOf",
    value: function valueOf() {
      return {
        attrs: this.attrs,
        dataset: this.dataset,
        selectors: this.selectors,
        reflexId: this.reflexId,
        resolveLate: this.resolveLate,
        suppressLogging: this.suppressLogging,
        xpathController: this.xpathController,
        xpathElement: this.xpathElement,
        inner_html: this.innerHTML,
        text_content: this.textContent,
        formSelector: this.formSelector,
        reflexController: this.reflexController,
        permanentAttributeName: this.permanentAttributeName,
        target: this.target,
        args: this.args,
        url: this.url,
        tabId: this.tabId,
        version: "3.5.0-pre9"
      };
    }
  }]);
  return T;
}();
var N, j, k;
var z = function z() {
    k = !0, document.body.classList.replace("stimulus-reflex-disconnected", "stimulus-reflex-connected"), h("stimulus-reflex:connected"), h("stimulus-reflex:action-cable:connected");
  },
  P = function P() {
    k = !1, document.body.classList.replace("stimulus-reflex-connected", "stimulus-reflex-disconnected"), h("stimulus-reflex:rejected"), h("stimulus-reflex:action-cable:rejected"), Debug.enabled && console.warn("Channel subscription was rejected.");
  },
  F = function F(e) {
    k = !1, document.body.classList.replace("stimulus-reflex-connected", "stimulus-reflex-disconnected"), h("stimulus-reflex:disconnected", e), h("stimulus-reflex:action-cable:disconnected", e);
  };
var M = {
  consumer: N,
  params: j,
  get subscriptionActive() {
    return k;
  },
  createSubscription: function createSubscription(e) {
    N = N || e.application.consumer || r();
    var t = e.StimulusReflex.channel,
      l = _objectSpread({
        channel: t
      }, j),
      n = JSON.stringify(l);
    e.StimulusReflex.subscription = N.subscriptions.findAll(n)[0] || N.subscriptions.create(l, {
      received: O,
      connected: z,
      rejected: P,
      disconnected: F
    });
  },
  connected: z,
  rejected: P,
  disconnected: F,
  set: function set(e, t) {
    N = e, j = t;
  }
};
var H = function H(e) {
    var _ref7 = e.detail || {},
      t = _ref7.stimulusReflex,
      r = _ref7.payload;
    if (!t) return;
    var l = t.reflexId,
      n = t.xpathElement,
      o = t.xpathController,
      a = b(o),
      s = b(n),
      d = i[l],
      c = d.promise;
    d.pendingOperations--, d.pendingOperations > 0 || (t.resolveLate || setTimeout(function () {
      return c.resolve({
        element: s,
        event: e,
        data: c.data,
        payload: r,
        reflexId: l,
        toString: function toString() {
          return "";
        }
      });
    }), setTimeout(function () {
      return $("success", s, a, l, r);
    }));
  },
  U = function U(e) {
    var _ref8 = e.detail || {},
      r = _ref8.stimulusReflex,
      l = _ref8.payload;
    if (!r) return;
    var n = r.reflexId,
      o = r.xpathElement,
      a = r.xpathController,
      s = b(a),
      d = b(o),
      u = i[n],
      f = u.promise;
    u.completedOperations++, c(e, !1), u.completedOperations < u.totalOperations || (r.resolveLate && setTimeout(function () {
      return f.resolve({
        element: d,
        event: e,
        data: f.data,
        payload: l,
        reflexId: n,
        toString: function toString() {
          return "";
        }
      });
    }), setTimeout(function () {
      return $("finalize", d, s, n, l);
    }), u.piggybackOperations.length && t.perform(u.piggybackOperations));
  },
  q = function q(e, t, r, l, n) {
    l.finalStage = "after", c(e, !1), setTimeout(function () {
      return r.resolve({
        data: r.data,
        element: n,
        event: e,
        payload: t,
        reflexId: r.data.reflexId,
        toString: function toString() {
          return "";
        }
      });
    });
  },
  Q = function Q(e, t, r, l, n) {
    l.finalStage = "halted", c(e, !0), setTimeout(function () {
      return r.resolve({
        data: r.data,
        element: n,
        event: e,
        payload: t,
        reflexId: r.data.reflexId,
        toString: function toString() {
          return "";
        }
      });
    });
  },
  V = function V(e, t, r, l, n) {
    l.finalStage = "after", u(e), setTimeout(function () {
      return r.reject({
        data: r.data,
        element: n,
        event: e,
        payload: t,
        reflexId: r.data.reflexId,
        error: e.detail.body,
        toString: function toString() {
          return e.detail.body;
        }
      });
    });
  };
var X = /*#__PURE__*/function (_e4) {
  _inherits(X, _e4);
  var _super = _createSuper(X);
  function X() {
    var _this2;
    _classCallCheck(this, X);
    for (var _len2 = arguments.length, e = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      e[_key2] = arguments[_key2];
    }
    _this2 = _super.call.apply(_super, [this].concat(e)), J(_assertThisInitialized(_this2));
    return _this2;
  }
  return _createClass(X);
}(e);
var Y = function Y(e) {
    var _ref9 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      t = _ref9.controller,
      r = _ref9.consumer,
      l = _ref9.debug,
      n = _ref9.params,
      a = _ref9.isolate,
      d = _ref9.deprecate;
    M.set(r, n), document.addEventListener("DOMContentLoaded", function () {
      document.body.classList.remove("stimulus-reflex-connected"), document.body.classList.add("stimulus-reflex-disconnected"), m.enabled && r && console.warn("Deprecation warning: the next version of StimulusReflex will obtain a reference to consumer via the Stimulus application object.\nPlease add 'application.consumer = consumer' to your index.js after your Stimulus application has been established, and remove the consumer key from your StimulusReflex initialize() options object."), m.enabled && S.disabled && console.warn("Deprecation warning: the next version of StimulusReflex will standardize isolation mode, and the isolate option will be removed.\nPlease update your applications to assume that every tab will be isolated.");
    }, {
      once: !0
    }), S.set(!!a), i.app = e, o.set(e), i.app.register("stimulus-reflex", t || X), s.set(!!l), void 0 !== d && m.set(d);
    new MutationObserver(D).observe(document.documentElement, {
      attributeFilter: [o.reflex, o.action],
      childList: !0,
      subtree: !0
    });
  },
  J = function J(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    e.StimulusReflex = _objectSpread(_objectSpread({}, t), {}, {
      channel: "StimulusReflex::Channel"
    }), M.createSubscription(e), Object.assign(e, {
      isActionCableConnectionOpen: function isActionCableConnectionOpen() {
        return this.StimulusReflex.subscription.consumer.connection.isOpen();
      },
      stimulate: function stimulate() {
        var _this3 = this;
        var e = location.href,
          t = Array.from(arguments),
          r = t.shift() || "StimulusReflex::Reflex#default_reflex",
          l = this.element,
          n = t[0] && t[0].nodeType === Node.ELEMENT_NODE ? t.shift() : l;
        if ("number" === n.type && n.validity && n.validity.badInput) return void (s.enabled && console.warn("Reflex aborted: invalid numeric input"));
        var a = {};
        if (t[0] && "object" == _typeof(t[0]) && Object.keys(t[0]).filter(function (e) {
          return ["attrs", "selectors", "reflexId", "resolveLate", "serializeForm", "suppressLogging", "includeInnerHTML", "includeTextContent"].includes(e);
        }).length) {
          var _e5 = t.shift();
          Object.keys(_e5).forEach(function (t) {
            return a[t] = _e5[t];
          });
        }
        var i = new T(a, n, l, this.identifier, o.reflexPermanent, r, t, e, W),
          c = i.reflexId;
        if (!this.isActionCableConnectionOpen()) throw "The ActionCable connection is not open! `this.isActionCableConnectionOpen()` must return true before calling `this.stimulate()`";
        if (!M.subscriptionActive) throw "The ActionCable channel subscription for StimulusReflex was rejected.";
        l.reflexController = l.reflexController || {}, l.reflexData = l.reflexData || {}, l.reflexError = l.reflexError || {}, l.reflexController[c] = this, l.reflexData[c] = i.valueOf(), $("before", n, l, c), setTimeout(function () {
          var _ref10 = l.reflexData[c] || {},
            e = _ref10.params,
            t = n.attributes[o.reflexSerializeForm];
          t && (a.serializeForm = "false" !== t.value);
          var r = n.closest(i.formSelector) || document.querySelector(i.formSelector) || n.closest("form");
          m.enabled && void 0 === a.serializeForm && r && console.warn("Deprecation warning: the next version of StimulusReflex will not serialize forms by default.\nPlease set ".concat(o.reflexSerializeForm, "=\"true\" on your Reflex Controller Element or pass { serializeForm: true } as an option to stimulate."));
          var s = !1 === a.serializeForm ? "" : function (e) {
            var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            if (!e) return "";
            var r = t.w || window,
              l = t.element,
              n = new r.FormData(e),
              o = Array.from(n, function (e) {
                return e.map(encodeURIComponent).join("=");
              }),
              a = e.querySelector("input[type=submit]");
            return l && l.name && "INPUT" === l.nodeName && "submit" === l.type ? o.push("".concat(encodeURIComponent(l.name), "=").concat(encodeURIComponent(l.value))) : a && a.name && o.push("".concat(encodeURIComponent(a.name), "=").concat(encodeURIComponent(a.value))), Array.from(o).join("&");
          }(r, {
            element: n
          });
          l.reflexData[c] = _objectSpread(_objectSpread({}, i.valueOf()), {}, {
            params: e,
            formData: s
          }), _this3.StimulusReflex.subscription.send(l.reflexData[c]);
        });
        var u = _(i.valueOf());
        return d(c, r, t, this.context.scope.identifier, n, l), u;
      },
      __perform: function __perform(e) {
        var t,
          r = e.target;
        for (; r && !t;) {
          t = r.getAttribute(o.reflex), t && t.trim().length || (r = r.parentElement);
        }
        var l = E(t).find(function (t) {
          return t.split("->")[0] === e.type;
        });
        l && (e.preventDefault(), e.stopPropagation(), this.stimulate(l.split("->")[1], r));
      }
    });
  },
  W = p(),
  Z = function Z(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    J(e, t);
  };
document.addEventListener("cable-ready:after-dispatch-event", function (e) {
  var _ref11 = e.detail || {},
    r = _ref11.stimulusReflex,
    l = _ref11.payload,
    n = _ref11.name,
    o = _ref11.body,
    a = n.split("-")[2];
  if (!r || !["nothing", "halted", "error"].includes(a)) return;
  var s = r.reflexId,
    d = r.xpathElement,
    c = r.xpathController,
    u = b(d),
    f = b(c),
    m = i[s],
    p = m.promise;
  switch (f && (f.reflexError = f.reflexError || {}, "error" === a && (f.reflexError[s] = o)), a) {
    case "nothing":
      q(e, l, p, m, u);
      break;
    case "error":
      V(e, l, p, m, u);
      break;
    case "halted":
      Q(e, l, p, m, u);
  }
  setTimeout(function () {
    return $(a, u, f, s, l);
  }), m.piggybackOperations.length && t.perform(m.piggybackOperations);
}), document.addEventListener("cable-ready:before-inner-html", H), document.addEventListener("cable-ready:before-morph", H), document.addEventListener("cable-ready:after-inner-html", U), document.addEventListener("cable-ready:after-morph", U), window.addEventListener("load", D);
var B = _objectSpread(_objectSpread({}, Object.freeze({
  __proto__: null,
  initialize: Y,
  register: J,
  useReflex: Z
})), {}, {
  get debug() {
    return s.value;
  },
  set debug(e) {
    s.set(!!e);
  },
  get deprecate() {
    return m.value;
  },
  set deprecate(e) {
    m.set(!!e);
  }
});
window.StimulusReflex = B;
export { B as default, Y as initialize, J as register, Z as useReflex };